// extracted by mini-css-extract-plugin
export default {"Button":"app-header-button_Button__X-eAE","ButtonText":"app-header-button_ButtonText__pvGB5"};